import React from 'react';

const BlockAds: React.FC = () => {
  return (
    <section 
      className="block-ads-section w-full px-6 md:px-12 lg:px-20 py-16 md:py-24"
      style={{ 
        background: 'linear-gradient(to bottom, #0a0a1a, #0a1726)' 
      }}
    >
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          Block all the ads you know and hate.
        </h2>
        <p className="text-lg text-white/80 mb-12">
          No more social media ads, video ads, banner ads, or popups.
        </p>

        {/* Icon Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Social Media Ads */}
          <div className="flex flex-col items-center">
            <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center mb-4 relative">
              {/* Blurred circular glow behind */}
              <div 
                className="absolute inset-0 rounded-full blur-xl opacity-30"
                style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.5)'
                }}
              ></div>
              {/* Eclipse circle behind icon */}
              <div 
                className="absolute inset-0 rounded-full"
                style={{ backgroundColor: '#08101c' }}
              ></div>
              <img 
                src="/images/social-media-ads-icon.png" 
                alt="Social Media Ads" 
                className="w-3/4 h-3/4 object-contain relative z-10"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <span className="text-white text-sm md:text-base">Social Media Ads</span>
          </div>

          {/* Pop-ups */}
          <div className="flex flex-col items-center">
            <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center mb-4 relative">
              {/* Blurred circular glow behind */}
              <div 
                className="absolute inset-0 rounded-full blur-xl opacity-30"
                style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.5)'
                }}
              ></div>
              {/* Eclipse circle behind icon */}
              <div 
                className="absolute inset-0 rounded-full"
                style={{ backgroundColor: '#08101c' }}
              ></div>
              <img 
                src="/images/popups.png" 
                alt="Pop-ups" 
                className="w-3/4 h-3/4 object-contain relative z-10"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <span className="text-white text-sm md:text-base">Pop-ups</span>
          </div>

          {/* Banner Ads */}
          <div className="flex flex-col items-center">
            <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center mb-4 relative">
              {/* Blurred circular glow behind */}
              <div 
                className="absolute inset-0 rounded-full blur-xl opacity-30"
                style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.5)'
                }}
              ></div>
              {/* Eclipse circle behind icon */}
              <div 
                className="absolute inset-0 rounded-full"
                style={{ backgroundColor: '#08101c' }}
              ></div>
              <img 
                src="/images/banner-ads.png" 
                alt="Banner Ads" 
                className="w-3/4 h-3/4 object-contain relative z-10"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <span className="text-white text-sm md:text-base">Banner Ads</span>
          </div>

          {/* Video Ads */}
          <div className="flex flex-col items-center">
            <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center mb-4 relative">
              {/* Blurred circular glow behind */}
              <div 
                className="absolute inset-0 rounded-full blur-xl opacity-30"
                style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.5)'
                }}
              ></div>
              {/* Eclipse circle behind icon */}
              <div 
                className="absolute inset-0 rounded-full"
                style={{ backgroundColor: '#08101c' }}
              ></div>
              <img 
                src="/images/videoads.png" 
                alt="Video Ads" 
                className="w-3/4 h-3/4 object-contain relative z-10"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <span className="text-white text-sm md:text-base">Video Ads</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlockAds;

